module.exports = __webpack_public_path__ + "img/multiple.5e57dad7.png";